var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35001 16.0249C3.32242 16.1599 3.32873 16.2996 3.36838 16.4316C3.40803 16.5636 3.47978 16.6836 3.57721 16.7811C3.67464 16.8785 3.7947 16.9502 3.92666 16.9899C4.05862 17.0295 4.19835 17.0358 4.33334 17.0083L7.50834 16.3583L4.00001 12.8499L3.35001 16.0249ZM8.28418 13.8416L6.51751 12.0749L13.5883 4.99992H13.59L15.3575 6.76742L8.28334 13.8424L8.28418 13.8416ZM16.5367 5.58909L14.77 3.82076C14.6151 3.66582 14.4311 3.543 14.2286 3.45934C14.0261 3.37569 13.8091 3.33284 13.59 3.33325C13.1633 3.33325 12.7367 3.49576 12.4108 3.82076L4.28001 11.9524L8.40501 16.0774L16.5358 7.94576C16.8483 7.63321 17.0238 7.20936 17.0238 6.76742C17.0238 6.32548 16.8483 5.90163 16.5358 5.58909H16.5367Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.16ca212f4f69b9f8b4b6e269c5317054.svg";
export { ForwardRef as ReactComponent };